import { css } from '@emotion/core';

export const styles = {
  container: css`
    padding: 16px 24px;
    text-align: left;

    @media (max-width: 768px) {
      padding: 12px;
    }

    @media (max-width: 480px) {
      padding: 8px;
    }
  `,
  tabContent: css`
    padding: 16px 0;

    @media (max-width: 768px) {
      padding: 8px 0;
    }

    .ant-collapse-content-box {
      @media (max-width: 480px) {
        padding: 8px !important;
      }
    }
  `,
  saveBar: css`
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 12px 0;
    border-top: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 10;
    flex-wrap: wrap;

    @media (max-width: 480px) {
      padding: 8px 0;

      button {
        flex: 1;
        min-width: 120px;
      }
    }
  `,
  jsonToolbar: css`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;

    .lastSaved {
      margin-left: auto;
      color: #888;
      font-size: 12px;
    }

    @media (max-width: 480px) {
      .lastSaved {
        margin-left: 0;
        width: 100%;
      }
    }
  `,
  diffTable: css`
    max-height: 50vh;
    overflow-y: auto;

    .diffRow {
      padding: 8px 0;
      border-bottom: 1px solid #f0f0f0;
      font-size: 12px;

      &:last-of-type {
        border-bottom: none;
      }

      code.diffKey {
        font-weight: 600;
        color: #333;
      }

      .diffValues {
        margin-top: 4px;
        word-break: break-all;

        .oldVal {
          color: #f5222d;
          text-decoration: line-through;
        }

        .newVal {
          color: #52c41a;
        }

        .arrow {
          margin: 0 8px;
          color: #aaa;
        }
      }
    }
  `,
};
